var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top_header_ b_border_"},[_c('div',{staticClass:"w1000_ clearfix_"},[_c('img',{staticClass:"logo_",attrs:{"src":_vm.logoUrl}}),_c('label',{staticClass:"com_"},[_vm._v("国际领先的保险和投资机构认证平台")]),_c('router-link',{staticClass:"f_r_",attrs:{"to":{name: 'home'}}},[_vm._v("返回首页")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }